// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__KJWE3","imageContainer":"Gallery_imageContainer__WtMkT","image":"Gallery_image__WGEUr"};